import type { AxiosRequestConfig } from 'axios'

// 请求头加上前往登录页的完整 URL，用于后端返回时跳转
export async function hrefRequestInterceptor(config: AxiosRequestConfig) {
  config.headers['href-url'] = window.location.href
  return config
}
